import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "location"
  static targets = ["button", "latitude", "longitude"]

  requestLocation(event) {
    if (!this.enabled) return

    event.preventDefault()
    event.stopImmediatePropagation()

    this.setLoadingState()

    this.send("request", {}, (message) => {
      this.handleLocationResponse(message)
    })
  }

  handleLocationResponse(message) {
    const data = message?.data || {}
    const status = data.status || (data.latitude || data.lat ? "granted" : "denied")

    if (status !== "granted") {
      this.restoreFromError(data.error || "permission_denied")
      return
    }

    const latitude = data.latitude ?? data.lat
    const longitude = data.longitude ?? data.lng

    if (latitude == null || longitude == null) {
      this.restoreFromError("invalid_coordinates")
      return
    }

    if (this.hasLatitudeTarget) this.latitudeTarget.value = latitude
    if (this.hasLongitudeTarget) this.longitudeTarget.value = longitude

    window.location.href = `/itineraries/new?lat=${encodeURIComponent(latitude)}&lng=${encodeURIComponent(longitude)}`
  }

  setLoadingState() {
    if (!this.hasButtonTarget) return

    this.buttonTarget.textContent = "Chargement..."
    this.buttonTarget.disabled = true
    this.buttonTarget.setAttribute("aria-busy", "true")
  }

  restoreFromError(error) {
    if (!this.hasButtonTarget) return

    this.buttonTarget.disabled = false
    this.buttonTarget.removeAttribute("aria-busy")

    if (error === "timeout") {
      this.buttonTarget.textContent = "Temps de reponse depasse - reessayer"
      return
    }

    this.buttonTarget.textContent = "Autoriser la geolocalisation dans les parametres de l'application"
  }
}
